/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import voltoKplcCms from 'volto-kplc-cms';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.8.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/div/plone/kplc-cms/frontend/core/packages/volto-slate/src","packageJson":"/div/plone/kplc-cms/frontend/core/packages/volto-slate/package.json","basePath":"/div/plone/kplc-cms/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-kplc-cms","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/div/plone/kplc-cms/frontend/packages/volto-kplc-cms/src","packageJson":"/div/plone/kplc-cms/frontend/packages/volto-kplc-cms/package.json","basePath":"/div/plone/kplc-cms/frontend/packages/volto-kplc-cms","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-kplc-cms/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoKplcCms];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
